export default __webpack_public_path__ + "static/media/With The Truth.cd904e9f.mp3";